// import { useState, useEffect, memo } from 'react';
// import axios from 'axios';
// import { useTranslation } from 'react-i18next';
// import CONFIG from '../../../config';

// import { getToken } from '../../../utils/auth';

// const StorageMonitor = memo(() => {
//     const { t } = useTranslation();
//     const [stats, setStats] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         fetchStats();
//         // Refresh every 30 seconds
//         const interval = setInterval(fetchStats, 30000);
//         return () => clearInterval(interval);
//     }, []);

//     const fetchStats = async () => {
//         try {
//             const token = getToken();
//             const res = await axios.get(`${CONFIG.API_URL}/api/storage/stats`, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             setStats(res.data);
//             setLoading(false);
//         } catch (error) {
//             console.error('Failed to fetch storage stats:', error);
//             setLoading(false);
//         }
//     };

//     if (loading) {
//         return (
//             <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
//                 <div className="animate-pulse">
//                     <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
//                     <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
//                     <div className="h-4 bg-gray-200 rounded w-2/3"></div>
//                 </div>
//             </div>
//         );
//     }

//     if (!stats) return null;

//     const getProgressColor = () => {
//         if (stats.usagePercent >= 95) return 'bg-red-600';
//         if (stats.usagePercent >= 80) return 'bg-yellow-500';
//         return 'bg-green-600';
//     };

//     const getAlertLevel = () => {
//         if (stats.usagePercent >= 95) return 'critical';
//         if (stats.usagePercent >= 80) return 'warning';
//         return 'normal';
//     };

//     const alertLevel = getAlertLevel();

//     // Safe data access
//     const activeStats = stats.active || { totalFiles: 0, totalImages: 0, totalVideos: 0, estimatedSizeMB: 0 };
//     const trashStats = stats.trash || { totalFiles: 0, totalImages: 0, estimatedSizeMB: 0 };

//     return (
//         <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
//             <div className="flex items-center justify-between mb-4">
//                 <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
//                     <span>🗄️</span>
//                     {t("admin.analytics_page.storage.title")}
//                 </h3>
//                 <span className="text-xs px-3 py-1 rounded-full bg-gray-100 text-gray-600 font-medium">
//                     {stats.provider?.toUpperCase()}
//                 </span>
//             </div>

//             {/* Progress Bar */}
//             <div className="mb-6">
//                 <div className="flex justify-between text-sm mb-2">
//                     <span className="font-bold text-gray-700">
//                         {stats.estimatedSizeMB} MB / {stats.limit} MB {t("admin.analytics_page.storage.total_used", "Total Used")}
//                     </span>
//                     <span className={`font-black ${alertLevel === 'critical' ? 'text-red-600' :
//                         alertLevel === 'warning' ? 'text-yellow-600' :
//                             'text-green-600'
//                         }`}>
//                         {stats.usagePercent?.toFixed(1)}%
//                     </span>
//                 </div>
//                 <div className="w-full bg-gray-100 rounded-full h-4 overflow-hidden shadow-inner ring-1 ring-black/5">
//                     <div
//                         className={`h-full transition-all duration-1000 ease-out ${getProgressColor()} relative`}
//                         style={{ width: `${Math.min(stats.usagePercent || 0, 100)}%` }}
//                     >
//                         <div className="absolute inset-0 bg-white/20 animate-pulse"></div>
//                     </div>
//                 </div>
//             </div>

//             {/* Alerts */}
//             {alertLevel === 'critical' && (
//                 <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-2xl animate-bounce">
//                     <p className="text-sm text-red-800 font-bold flex items-center gap-2">
//                         <span>🚨</span> {t("admin.analytics_page.storage.critical_msg", { percent: stats.usagePercent?.toFixed(1) })}
//                     </p>
//                 </div>
//             )}

//             {/* Stats Breakdown Grid */}
//             <div className="grid grid-cols-2 gap-4 mb-6">
//                 <div className="p-4 bg-blue-50/50 rounded-2xl border border-blue-100/50">
//                     <div className="text-[10px] font-black uppercase tracking-widest text-blue-400 mb-1">
//                         {t("admin.analytics_page.storage.active_usage", "Live Content")}
//                     </div>
//                     <div className="text-xl font-black text-blue-600">
//                         {activeStats.estimatedSizeMB} <span className="text-xs font-bold text-blue-300">MB</span>
//                     </div>
//                     <div className="text-[10px] font-bold text-blue-400 mt-1">
//                         {activeStats.totalFiles} {t("admin.analytics_page.storage.files", "files")}
//                     </div>
//                 </div>

//                 <div className="p-4 bg-amber-50/50 rounded-2xl border border-amber-100/50">
//                     <div className="text-[10px] font-black uppercase tracking-widest text-amber-500/60 mb-1">
//                         {t("admin.analytics_page.storage.trash_usage", "Reclaimable (Trash)")}
//                     </div>
//                     <div className="text-xl font-black text-amber-600">
//                         {trashStats.estimatedSizeMB} <span className="text-xs font-bold text-amber-400">MB</span>
//                     </div>
//                     <div className="text-[10px] font-bold text-amber-500/60 mt-1">
//                         {trashStats.totalFiles} {t("admin.analytics_page.storage.files", "files")}
//                     </div>
//                 </div>
//             </div>

//             {/* File Types Breakdown */}
//             <div className="space-y-3 p-4 bg-gray-50/50 rounded-2xl border border-gray-100">
//                 <div className="flex items-center justify-between">
//                     <div className="flex items-center gap-2">
//                         <span className="w-2 h-2 rounded-full bg-blue-500"></span>
//                         <span className="text-xs font-bold text-gray-600">{t("admin.analytics_page.storage.images")}</span>
//                     </div>
//                     <span className="text-xs font-black text-gray-900">{(activeStats.totalImages || 0) + (trashStats.totalImages || 0)}</span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                     <div className="flex items-center gap-2">
//                         <span className="w-2 h-2 rounded-full bg-purple-500"></span>
//                         <span className="text-xs font-bold text-gray-600">{t("admin.analytics_page.storage.videos")}</span>
//                     </div>
//                     <span className="text-xs font-black text-gray-900">{activeStats.totalVideos || 0}</span>
//                 </div>
//             </div>

//             {/* Provider Info */}
//             <div className="mt-4 pt-4 border-t border-gray-200">
//                 {/* <p className="text-xs text-gray-500"> */}
//                 <p className="text-xs text-gray-500 mb-2">
//                     {stats.provider === 'cloudinary' ? (
//                         <>{t("admin.analytics_page.storage.providers.cloudinary")}</>
//                     ) : stats.provider === 'r2' ? (
//                         <>{t("admin.analytics_page.storage.providers.r2")}</>
//                     ) : (
//                         <>{t("admin.analytics_page.storage.providers.supabase")}</>
//                     )}
//                 </p>

//                 <div className="flex items-center gap-1.5 p-2 bg-blue-50/50 rounded-lg border border-blue-100/50">
//                     <span className="text-blue-500 text-xs">ℹ️</span>
//                     <p className="text-[10px] text-blue-700 leading-tight">
//                         {t("admin.analytics_page.storage.db_note", "Statistics are estimated based on database records. Usage may not immediately change when switching providers.")}
//                     </p>
//                 </div>
//             </div>
//         </div>
//     );
// });

// export default StorageMonitor;





import { useState, useEffect, memo } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import CONFIG from '../../../config';

import { getToken } from '../../../utils/auth';

const StorageMonitor = memo(() => {
    const { t } = useTranslation();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
        // Refresh every 30 seconds
        const interval = setInterval(fetchStats, 30000);
        return () => clearInterval(interval);
    }, []);

    const fetchStats = async () => {
        try {
            const token = getToken();
            const res = await axios.get(`${CONFIG.API_URL}/api/admin/storage/stats`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setStats(res.data);
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch storage stats:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <div className="animate-pulse">
                    <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
                    <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                </div>
            </div>
        );
    }

    if (!stats) return null;

    const getProgressColor = () => {
        if (stats.usagePercent >= 95) return 'bg-red-600';
        if (stats.usagePercent >= 80) return 'bg-yellow-500';
        return 'bg-green-600';
    };

    const getAlertLevel = () => {
        if (stats.usagePercent >= 95) return 'critical';
        if (stats.usagePercent >= 80) return 'warning';
        return 'normal';
    };

    const alertLevel = getAlertLevel();

    // Safe data access
    const activeStats = stats.active || { totalFiles: 0, totalImages: 0, totalVideos: 0, estimatedSizeMB: 0 };
    const trashStats = stats.trash || { totalFiles: 0, totalImages: 0, estimatedSizeMB: 0 };

    return (
        <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                    <span>🗄️</span>
                    {t("admin.analytics_page.storage.title")}
                </h3>
                <span className="text-xs px-3 py-1 rounded-full bg-gray-100 text-gray-600 font-medium">
                    {stats.provider?.toUpperCase()}
                </span>
            </div>

            {/* Progress Bar */}
            <div className="mb-6">
                <div className="flex justify-between text-sm mb-2">
                    <span className="font-bold text-gray-700">
                        {stats.estimatedSizeMB} MB / {stats.limit} MB {t("admin.analytics_page.storage.total_used", "Total Used")}
                    </span>
                    <span className={`font-black ${alertLevel === 'critical' ? 'text-red-600' :
                        alertLevel === 'warning' ? 'text-yellow-600' :
                            'text-green-600'
                        }`}>
                        {stats.usagePercent?.toFixed(1)}%
                    </span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-4 overflow-hidden shadow-inner ring-1 ring-black/5">
                    <div
                        className={`h-full transition-all duration-1000 ease-out ${getProgressColor()} relative`}
                        style={{ width: `${Math.min(stats.usagePercent || 0, 100)}%` }}
                    >
                        <div className="absolute inset-0 bg-white/20 animate-pulse"></div>
                    </div>
                </div>
            </div>

            {/* Alerts */}
            {alertLevel === 'critical' && (
                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-2xl animate-bounce">
                    <p className="text-sm text-red-800 font-bold flex items-center gap-2">
                        <span>🚨</span> {t("admin.analytics_page.storage.critical_msg", { percent: stats.usagePercent?.toFixed(1) })}
                    </p>
                </div>
            )}

            {/* Stats Breakdown Grid */}
            <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="p-4 bg-blue-50/50 rounded-2xl border border-blue-100/50">
                    <div className="text-[10px] font-black uppercase tracking-widest text-blue-400 mb-1">
                        {t("admin.analytics_page.storage.active_usage", "Live Content")}
                    </div>
                    <div className="text-xl font-black text-blue-600">
                        {activeStats.estimatedSizeMB} <span className="text-xs font-bold text-blue-300">MB</span>
                    </div>
                    <div className="text-[10px] font-bold text-blue-400 mt-1">
                        {activeStats.totalFiles} {t("admin.analytics_page.storage.files", "files")}
                    </div>
                </div>

                <div className="p-4 bg-amber-50/50 rounded-2xl border border-amber-100/50">
                    <div className="text-[10px] font-black uppercase tracking-widest text-amber-500/60 mb-1">
                        {t("admin.analytics_page.storage.trash_usage", "Reclaimable (Trash)")}
                    </div>
                    <div className="text-xl font-black text-amber-600">
                        {trashStats.estimatedSizeMB} <span className="text-xs font-bold text-amber-400">MB</span>
                    </div>
                    <div className="text-[10px] font-bold text-amber-500/60 mt-1">
                        {trashStats.totalFiles} {t("admin.analytics_page.storage.files", "files")}
                    </div>
                </div>
            </div>

            {/* File Types Breakdown */}
            <div className="space-y-3 p-4 bg-gray-50/50 rounded-2xl border border-gray-100">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                        <span className="text-xs font-bold text-gray-600">{t("admin.analytics_page.storage.images")}</span>
                    </div>
                    <span className="text-xs font-black text-gray-900">{(activeStats.totalImages || 0) + (trashStats.totalImages || 0)}</span>
                </div>
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-purple-500"></span>
                        <span className="text-xs font-bold text-gray-600">{t("admin.analytics_page.storage.videos")}</span>
                    </div>
                    <span className="text-xs font-black text-gray-900">{activeStats.totalVideos || 0}</span>
                </div>
            </div>

            {/* Provider Info */}
            <div className="mt-4 pt-4 border-t border-gray-200">
                {/* <p className="text-xs text-gray-500"> */}
                <p className="text-xs text-gray-500 mb-2">
                    {stats.provider === 'cloudinary' ? (
                        <>{t("admin.analytics_page.storage.providers.cloudinary")}</>
                    ) : stats.provider === 'r2' ? (
                        <>{t("admin.analytics_page.storage.providers.r2")}</>
                    ) : (
                        <>{t("admin.analytics_page.storage.providers.supabase")}</>
                    )}
                </p>

                <div className="flex items-center gap-1.5 p-2 bg-blue-50/50 rounded-lg border border-blue-100/50">
                    <span className="text-blue-500 text-xs">ℹ️</span>
                    <p className="text-[10px] text-blue-700 leading-tight">
                        {t("admin.analytics_page.storage.db_note", "Statistics are estimated based on database records. Usage may not immediately change when switching providers.")}
                    </p>
                </div>
            </div>
        </div>
    );
});

export default StorageMonitor;
